const FormatPicker = () => {
  return (
    <div className="tw-py-6 tw-flex tw-items-center tw-justify-center md:tw-justify-start tw-space-x-4 md:tw-justify-self-start">
      <img
        src="/Mktg/images/tsg/svg/webinars.svg"
        alt="webinars calendar"
        className="tw-w-6 tw-h-6"
      />
      <span className="uppercased-heading tw-select-none">
        Webinars calendar
      </span>
    </div>
  );
};

export default FormatPicker;
